<template>
  <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="模板名称" name='time'>
      <a-input placeholder="请输入模板名称进行搜索" v-model:value="search.keyword" style="width:280px" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit' class='m-r-10' @click="pageSearchChange">搜索</a-button>
    </a-form-item>
  </a-form>
  <a-tabs v-model:activeKey="search.type" @change="changeType" v-if="!template_type">
    <a-tab-pane key="1" tab="H5模板"></a-tab-pane>
    <a-tab-pane key="2" tab="小程序模板"></a-tab-pane>
  </a-tabs>
  <!-- 模板类型 1 H5模板 2 云店模板 3 溯源模板 4 大转盘模板 5会员卡模板 6导购模板 7点球模板-->
  <a-table
    :pagination="false"
    :loading="loading"
    bordered
    rowKey="id"
    :columns="columns"
    :data-source="list"
    :scroll="{ x: 900 }"
  >
    <template v-slot:templateName="{ record }">
      {{ record.is_default ? '默认模板' : (record.name || '模板') }}
    </template>
    <template v-slot:templateType="{ record }">
      {{ record.type_text || record.affiliation_text || '-' }}
    </template>
    <template v-slot:defaultStatus="{ record }">
      <a-tag v-if="record.is_default" color="blue">默认模板</a-tag>
      <span v-else>-</span>
    </template>
    <template v-slot:templateAction="{ record }">
      <a-button type="primary" @click="choose(record)">选择</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
</template>

<script>
import { onMounted, reactive, toRefs } from "vue";
import { getActivityTemplate } from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
const def = {
  page: 1,
  limit: 6,
  type:"1",
  keyword: "",
  label_type:""
};
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 90,
  },
  {
    title: "模板名称",
    dataIndex: "name",
    key: "name",
    width: 220,
    ellipsis: true,
    slots: { customRender: "templateName" },
  },
  {
    title: "模板类型",
    dataIndex: "type_text",
    key: "type_text",
    width: 150,
    slots: { customRender: "templateType" },
  },
  {
    title: "默认状态",
    dataIndex: "is_default",
    key: "is_default",
    width: 120,
    slots: { customRender: "defaultStatus" },
  },
  {
    title: "创建时间",
    dataIndex: "created_time",
    key: "created_time",
    width: 180,
  },
  {
    title: "备注",
    dataIndex: "remarks",
    key: "remarks",
    ellipsis: true,
  },
  {
    title: "操作",
    key: "action",
    width: 100,
    fixed: "right",
    slots: { customRender: "templateAction" },
  },
];
export default {
  name: "selectTemplate",
  props:{
    template_type:String,
    label_type:String
  },
  setup(props, { emit }) {
    const state = reactive({
      search: def,
      total: 0,
      list: [],
      loading: false,
    });
    const initData = async () => {
      state.loading = true;
      let result = await getActivityTemplate(state.search)
        .then((res) => res.data)
        .catch((error) => error);
      state.loading = false;
      if (iscode(result)) {
        state.list = result.data;
        state.total = result.meta.total;
      }
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      state.search = { ...state.search, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      state.search.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      state.search.page = 1;
      state.search.limit = limit;
      initData();
    };
    onMounted(() => {
      state.search = {
        page: 1,
        limit: 6,
        type:"1",
        keyword: "",
      };
      state.search.type=props.template_type==4?1:props.template_type;
      state.search.label_type = props.label_type;
      initData();
    });
    const choose = (v) => {
      emit("success", v);
    };
    const changeType=()=>{
      state.search.page = 1;


      initData();
    }
    return {
      ...toRefs(state),
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      choose,
      changeType,
      columns
    };
  },
};
</script>
